import useActivityController from '@admin/api/useActivityController'
import Button from '@blocks/Button'
import EmphasizedContent from '@blocks/EmphasizedContent'
import Grid from '@blocks/Grid'
import MainContainer from '@blocks/MainContainer'
import Table from '@components/modules/Table'
import { notify } from '@helpers'
import useTitle from '@hooks/useTitle'
import useMainTemplate from '@templates/Main/hooks/useMainTemplate'
import React from 'react'
import columns from './config/columns'

export default function ActivityPage() {
    const controller = useActivityController()
    const activity = controller.index.use("admin:activity")

    useTitle("Logs")
    useMainTemplate({ category: "logs" })

    const more = async () => {
        await activity.fresh({ more: true })
        notify("Successfully loaded more rows.")
    }

    return (
        <MainContainer heading="Logs">
            <Grid>
                <Table data={activity.data} columns={columns} />
                {activity.data?.length === 1000 && (
                    <EmphasizedContent>
                        <Grid gap="10px">
                            <p>Notice: Table contains only last 1000 rows.</p>
                            <Button type="tertiary" onClick={more}>Show more</Button>
                        </Grid>
                    </EmphasizedContent>
                )}
            </Grid>
        </MainContainer>
    )
}